<script>
// import Layout from '@/Layouts/Layout.vue'
import HeaderApp from '@/Components/HomeComponents/Header.vue'
import Cover from '@/Components/HomeComponents/Cover.vue'
import Feature from '@/Components/HomeComponents/FeatureSection.vue'
import Video from '@/Components/HomeComponents/Video.vue'
import Hero1 from '@/Components/HomeComponents/HeroContent.vue'
import Hero2 from '@/Components/HomeComponents/HeroContentHome.vue'
import Organization from '@/Components/HomeComponents/Organization.vue'
import Members from '@/Components/HomeComponents/Members.vue'
import { Head, usePage, Link } from '@inertiajs/vue3'



export default {
  components: {
    HeaderApp,
    Cover,
    Head,
    Feature,
    Video,
    Hero1,
    Hero2,
    Organization,
    Members,
  },
  props: {
    canLogin: {
        type: Boolean,
    },
    canRegister: {
        type: Boolean,
    },

  },
  data(){
    return {
      componentInfo: {
        'canLogin': this.canLogin,
        'canRegister': this.canRegister,

      }
    }
  },
  mounted(){
    // console.log(usePage().props)
  }
}

</script>

<template>
  
  <Head>
    <title>Inicio</title>
    <meta name="description" content="Pachamama OBC asociación sin fines de lucro por la conservación de la naturaleza.">
  </Head>

    <HeaderApp v-bind:component-data="componentInfo"/>
    <Cover />
    <Video />
    <Feature />
    <Hero1 />
    <Hero2 />
    <!-- Cover image organizacion -->
    <organization />
    <!-- Meet members -->
    <Members /> 
  
</template>

